import { CargoCondition } from '@/models/CargoCondition'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<CargoCondition>(CargoCondition, {
	namespaced: true
})
